function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.8
},
/*#__PURE__*/
React.createElement("path", {
  d: "M10 20a10 10 0 1110-10 10.011 10.011 0 01-10 10zM10 .984A9.016 9.016 0 1019.016 10 9.026 9.026 0 0010 .984z"
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M13.279 13.771a.49.49 0 01-.348-.144L6.374 7.07a.495.495 0 01.7-.7l6.556 6.56a.492.492 0 01-.348.84z"
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M6.722 13.771a.492.492 0 01-.348-.84l6.557-6.557a.495.495 0 11.7.7L7.07 13.63a.49.49 0 01-.348.141z"
}));

var SvgClear = function SvgClear(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 20,
      height: 20,
      viewBox: "0 0 20 20",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgClear, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/Clear.1f2a40bd.svg";
export { ForwardRef as ReactComponent };